// extracted by mini-css-extract-plugin
var _1 = "pU9Z8FW1xraxjZssK8yB";
export { _1 as "chip" }
